const LEDGER_CANISTER_ID = 'ryjl3-tyaaa-aaaaa-aaaba-cai';
const CSDEMO_CANSITER_ID = '6ayzd-gyaaa-aaaan-qdm3q-cai';

export {
    LEDGER_CANISTER_ID,
    CSDEMO_CANSITER_ID
}
